import colorPalette from './colorPalette'

const {
  COLOR_LANDSCAPE,
  COLOR_BORDERS,
  COLOR_WATER,
  COLOR_LINE,
  COLOR_POINT_FILL,
  COLOR_SELECTED_POINT
} = colorPalette

const COLORS = {
  BORDERS: COLOR_BORDERS,
  LANDSCAPE: COLOR_LANDSCAPE,
  LINE: COLOR_LINE,
  POINT: COLOR_SELECTED_POINT,
  POINT_FILL: COLOR_POINT_FILL,
  WATER: COLOR_WATER
}

const POINT_MARKER_ICON_CONFIG = {
  path: 'M 0, 0 m -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0',
  strokeOpacity: 0.7,
  strokeWeight: 4,
  strokeColor: COLORS.POINT,
  fillColor: COLORS.POINT_FILL,
  fillOpacity: 0.7,
  scale: 1
}

const LINE_SYMBOL_CONFIG = {
  path: 'M 0,-2 0,2',
  strokeOpacity: 1,
  strokeWeight: 2,
  scale: 1
}

const LINE_PATH_CONFIG = {
  clickable: false,
  geodesic: false,
  strokeOpacity: 0,
  strokeColor: COLORS.LINE,
  icons: [
    {
      icon: LINE_SYMBOL_CONFIG,
      repeat: '10px'
    }
  ]
}

const mapSettings = {
  clickableIcons: false,
  streetViewControl: false,
  panControlOptions: false,
  //gestureHandling: 'cooperative',
  //backgroundColor: COLORS.LANDSCAPE,
  mapTypeControl: false,
  disableDefaultUI: true,
  // zoomControlOptions: {
  //   style: 'SMALL'
  // },
  center: { lat: -34, lng: -58 },
  zoom: 5,
  minZoom: 3,
  // maxZoom: 5
  styles: [
    {
       featureType: "administrative",
       elementType: "labels.text.fill",
       stylers: [
            {
               color: "#676766"
            }
        ]
    },
    {
       featureType: "administrative.country",
       elementType: "geometry.stroke",
       stylers: [
            {
               color: "#dea3fc"
            },
            {
               weight: "2.00"
            }
        ]
    },
    {
       featureType: "administrative.province",
       elementType: "geometry.stroke",
       stylers: [
            {
               weight: "1.00"
            }
        ]
    },
    {
       featureType: "landscape",
       elementType: "all",
       stylers: [
            {
               color: "#f5f6f1"
            }
        ]
    },
    {
       featureType: "landscape",
       elementType: "geometry",
       stylers: [
            {
               color: "#eff1e8"
            }
        ]
    },
    {
       featureType: "landscape",
       elementType: "labels.text.fill",
       stylers: [
            {
               color: "#898989"
            }
        ]
    },
    {
       featureType: "poi",
       elementType: "all",
       stylers: [
            {
               visibility: "off"
            }
        ]
    },
    {
       featureType: "road",
       elementType: "all",
       stylers: [
            {
               saturation: -100
            },
            {
               lightness: 45
            }
        ]
    },
    {
       featureType: "road.highway",
       elementType: "all",
       stylers: [
            {
               visibility: "simplified"
            }
        ]
    },
    {
       featureType: "road.highway",
       elementType: "geometry.fill",
       stylers: [
            {
               color: "#ddd2ba"
            },
            {
               weight: "2.00"
            }
        ]
    },
    {
       featureType: "road.highway.controlled_access",
       elementType: "geometry.fill",
       stylers: [
            {
               color: "#febd1a"
            },
            {
               weight: "2.00"
            }
        ]
    },
    {
       featureType: "road.arterial",
       elementType: "geometry.fill",
       stylers: [
            {
               color: "#e1e3dd"
            }
        ]
    },
    {
       featureType: "road.arterial",
       elementType: "labels.icon",
       stylers: [
            {
               visibility: "off"
            }
        ]
    },
    {
       featureType: "road.local",
       elementType: "geometry.fill",
       stylers: [
            {
               color: "#ffffff"
            },
            {
               weight: "1.00"
            }
        ]
    },
    {
       featureType: "road.local",
       elementType: "geometry.stroke",
       stylers: [
            {
               weight: "1.00"
            },
            {
               color: "#ffffff"
            }
        ]
    },
    {
       featureType: "road.local",
       elementType: "labels.text.fill",
       stylers: [
            {
               color: "#807d7d"
            }
        ]
    },
    {
       featureType: "road.local",
       elementType: "labels.text.stroke",
       stylers: [
            {
               color: "#ffffff"
            },
            {
               weight: "6"
            }
        ]
    },
    {
       featureType: "transit",
       elementType: "all",
       stylers: [
            {
               visibility: "off"
            }
        ]
    },
    {
       featureType: "water",
       elementType: "all",
       stylers: [
            {
               color: "#cdedef"
            },
            {
               visibility: "on"
            }
        ]
    }
]
}

export { mapSettings, LINE_PATH_CONFIG, POINT_MARKER_ICON_CONFIG }
